import React from 'react';
//import {useState} from 'react';
import {useContext} from 'react';
import { Link } from 'react-router-dom';
import "./mundos.css";
//import Bd from "../../bd"

import Header from '../../components/Header';
import MFooter from '../../components/MFooter'
//import ImportIcons from '../../components/ImportIcons'

//  import useFind from '../../hooks/useFind'
import {useFetch} from '../../hooks/useFetch'
import {UserContext} from '../../hooks/UserContext'

let destravar = false;

function Mundos(){

	return (
	  <>
	    {/* menu superior do dj*/}
	    <Header/>
	    {/*Conteudo*/}
	    <MundosBody/>
	    {/*Rodape*/}
	    <MFooter/>
		<p>Ícones feitos pelo Freepik de www.flaticon.com</p>
	  </>
	);
};

function MundosBody(){
	const { user } = useContext(UserContext);
	//console.log("mb. user ",user)
	const mundos_modelo = [{id:1,status:'loading'},{id:2,status:'loading'},{id:3,status:'loading'},{id:4,status:'loading'}]//[{id:1,status:'active'},{id:2,status:'blocked'},{id:3,status:'maintenance'},{id:5,status:'maintenance'}]
	// const mundos = mundos_modelo;
	const {data: mundos, } = useFetch('mundos',mundos_modelo);
	//const {data: userData, isLoadingUserMundos} = useFind(`user/mu${user.id}`,[]);
	const {data: userDataM, /*mutate*/} = useFetch(`user/mu${user.id}`);
	// const mundos = isLoadingMundos ? [{id:1,status:'active'},{id:2,status:'blocked'},{id:3,status:'maintenance'},{id:5,status:'maintenance'}] : mundosData
	//console.log("p.mundos",{mundos,isLoadingMundos})
	//console.log("p.userData",userDataM)

	if (user.patente>=3){
		destravar = true;
	}
	//console.log("user",user)
	function MundoBloco(props){
		const {mundo, UserMundos, blocked, unblock, maintenance, making, hide, loading } = props
		//const mundo_stts = UserMundos
		const ansMundoConc = UserMundos.some(elem => elem.position === mundo.position-1);
		const mundoLock = !UserMundos.some(elem => elem.id === mundo.id); //elem.position === mundo.position+1
		//console.log("\n\n*******",{mundo,UserMundos,ansMundoConc},"*-*-*-*-*-*-*")
		if (!!hide){
			return <></>
		}
		if (!!loading){
			return (
				<div className={"mundos-box mundo-loading"}>
					<div className={"mundos-card"}>
						<div title='carregando marco' src="" className="mundos-icon"/>
						<span className="mundos-title" >{"  "}</span>
						<span className="mundos-subtitle">{"  "}</span>
					</div>
				</div>
			)
		}
		if (!!maintenance){
			return (
				<div className={"mundos-box mundo-Lock"}>
					<div className={"mundos-card"}>
						<img alt='Marco em construção' src={process.env.PUBLIC_URL+"/img/mundos_logo/foguete_manutencao.jpg"} className="mundos-icon-rec"/>
						<span className="mundos-title" >{`${mundo.titulo} - Em Manutenção`}</span>
						<span className="mundos-subtitle">{`Não se preocupe, nossos astronautas estão trabalhando para liberar esse marco logo!`}</span>
					</div>
				</div>)
		}
		// em construção
		if ((!!blocked || making) && !unblock){
			return (
				<div className={"mundos-box mundo-Lock"}>
					<div className={"mundos-card"}>
						<img alt='Marco em construção' src={process.env.PUBLIC_URL+"/img/mundos_logo/foguete_construindo2.jpg"} className="mundos-icon-rec"/>
						<span className="mundos-title" >Em construção</span>
						<span className="mundos-subtitle">Estamos arrumando a espaçonave e preparando o ambiente para você</span>
					</div>
				</div>)
		}
		// bloqueado
		if (!unblock && mundoLock && mundo.position!==1 && !ansMundoConc){
			return (
				<div className={"mundos-box mundo-Lock"}>
					<div className={"mundos-card"}>
						<img alt='Complete as outras etapas para desbloquear' src={process.env.PUBLIC_URL+"/img/mundos_logo/bloqueado.svg"} className="mundos-icon"/>
						<span className="mundos-title" >Bloqueado</span>
						<span className="mundos-subtitle">Complete as tarefas anteriores para desbloquear</span>
					</div>
				</div>)
		}
		// Ativado
		return (
			<Link to={`/planetas/${mundo.position}/1`} className={mundoLock ? "mundos-box" : "mundos-box mundo-ok"}>
				<div className={"mundos-card"}>
					<img alt='' src={process.env.PUBLIC_URL+"/img/mundos_logo/"+mundo.icone} className="mundos-icon"/>
					<span className="mundos-title" >{mundo.titulo}</span>
					<span className="mundos-subtitle">{mundo.subtitulo}</span>
				</div>
			</Link>
		)
	}
	const UserMundos = !userDataM ? [] : userDataM.data.mundos
		/*
			status: [
                'disabled', 'active', 'making', 'hide',
                'blocked', 'unblock', 'maintenance',
            ],
		*/
	const lista_mundos = mundos.map((mundo,i) => (<MundoBloco
		mundo={mundo}
		key={i}
		UserMundos={UserMundos}
		blocked = {mundo.status==='blocked'}
		making = {mundo.status==='making'}
		unblock = {destravar || mundo.status==='unblock'}
		maintenance = {mundo.status==='maintenance'}
		hide = {mundo.status==='hide'}
		loading={mundo.status==='loading'}
	/>)) //<< colocar caixas genericas
	// console.log("mm",mundos)
	const quebrar_marte = 7;
	const quebrar_venus = 13;
	console.log(lista_mundos)
	return (
	<section id="mundos" className="mundos">
		<Planeta planeta={planetas[0]} listaMundos = {lista_mundos.slice(0,quebrar_marte)}/>
		{ (UserMundos.some(elem => elem.nome ==="teste-final-df" || destravar)
		  )&&<Planeta planeta={planetas[1]} listaMundos = {lista_mundos.slice(quebrar_marte,quebrar_venus)}/>
		}
		{ (UserMundos.some(elem => elem.nome ==="em" || destravar)
		  )&&<Planeta planeta={planetas[2]} listaMundos = {lista_mundos.slice(quebrar_venus,quebrar_venus+6)}/>
		}
		{ (UserMundos.some(elem => elem.nome ==="fechadura_inteligente" || destravar)
		  )&&<Planeta planeta={planetas[3]} listaMundos = {lista_mundos.slice(quebrar_venus+6*1,quebrar_venus+6*2)}/>
		}
		{ (UserMundos.some(elem => elem.nome ==="teste-final-jupiter" || destravar)
		  )&&<Planeta planeta={planetas[4]} listaMundos = {lista_mundos.slice(quebrar_venus+6*2,quebrar_venus+6*3)}/>
		}
		{ (UserMundos.some(elem => elem.nome ==="teste-final-saturno" || destravar)
		  )&&<Planeta planeta={planetas[5]} listaMundos = {lista_mundos.slice(quebrar_venus+6*3,quebrar_venus+6*4)}/>
		}
		{ (UserMundos.some(elem => elem.nome ==="teste-final-urano" || destravar)
		  )&&<Planeta planeta={planetas[6]} listaMundos = {lista_mundos.slice(quebrar_venus+6*4,quebrar_venus+6*5)}/>
		}
		{ (UserMundos.some(elem => elem.nome ==="teste-final-netuno" || destravar)
		  )&&<Planeta planeta={planetas[7]} listaMundos = {lista_mundos.slice(quebrar_venus+6*5,quebrar_venus+6*6)}/>
		}
		{/*teste-final-terra*/}
	</section>

	);
}

export default Mundos;

const planetas = [
	{
		titulo:"Primeira missão",
		subtitulo:"Construindo uma cidade inteligente em Marte",
	},{
		titulo:"Segunda Missão",
		subtitulo:"Construindo uma plantação inteligente em Vênus",
	},{
		titulo:"Terceira Missão",
		subtitulo:"Construindo uma casa inteligente em Mercúrio",
	},{
		titulo:"Quarta Missão",
		subtitulo:"Levando cultura maranhense para Júpiter",
	}, {
		titulo:"Quinta Missão",
		subtitulo:"Construindo jogos em Saturno",
	}, {
		titulo:"Sexta Missão",
		subtitulo:"Automatizando carros em Urano",
	}, {
		titulo:"Sétima Missão",
		subtitulo:"Acessibilidade em Netuno",
	}, {
		titulo:"Oitava Missão",
		subtitulo:"Sustentabilidade na Terra",
	}
]
function Planeta({planeta, listaMundos}){
	const {titulo, subtitulo} = planeta;
	return (
		<div className="container" id="Vênus">
			<h4 className="page-title --mundos-spacing">{titulo}</h4>
			<h5 className="page-title --mundos-spacing">{subtitulo}</h5>
			<div className="mundos-area">
				{listaMundos}
			</div>
		</div>
	)
}

export function Parabens(){
	return (
		<Link to="/planetas">
			<p>parabéns!</p>
		</Link>
	)
};

/*
const images = require.context('../../asset/img/mundos_logo/', true);
const loadImage = imageName => (assets(`./${imageName}`).default);
*/





/*

function MundoConteiner({mundo}){


	const listaMundos = mundo.map((faseData,id) => (
		<ListaCompo faseData={faseData} id={id} id_fase={id_fase} userData={userData}/>
	));

	Fases = (<div className="mundos-area">
		<Link to="" className="mundos-box">
			<div className="mundos-card">
				<img alt='' src="Mundo1.png" className="mundos-icon"/>
				<span className="mundos-name" >Conhecendo sobre o MM</span>
				<span className="mundos-title">Vem conhecer o que é o Maratoninha</span>
			</div>
		</Link>
	</div>)

	return (
		<div className="container">
			<h4 className="page-title --mundos-spacing">{mundo.mundoNome}</h4>

			</Fases>
		</div>

	);
}*/
/*<html>

<body>

	<div className="container">
		<h4 className="page-title --mundos-spacing">Preparativos</h4>
		<div className="mundos-area">

			<a href="" className="mundos-box">
				<div className="mundos-card">
					<img src="Mundo1.png" className="mundos-icon">
					<span className="mundos-name">Conhecendo sobre o MM</span>
					<span className="mundos-title">Vem conhecer o que é o Maratoninha</span>
				</div>
			</a>
			<a href="" className="mundos-box">
				<div className="mundos-card">
					<img src="Mundo1.png" className="mundos-icon">
					<span className="mundos-name">Sistema de Controle</span>
					<span className="mundos-title">Preparando o Sistema de Controle</span>
				</div>
			</a>


		</div>
	</div>
</section>

</section>
</body>

</html>

*/
